function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-utensils"
}, "Utenstils Icon-");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.21,49a9,9,0,1,1,9-9A9,9,0,0,1,40.21,49Zm0,3a12,12,0,1,0-12-12A12,12,0,0,0,40.21,52Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 40.21,
  cy: 40,
  r: 6.5
});

var SvgIconUtensils = function SvgIconUtensils(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-utensils",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-utensils"
  }, title) : null, _ref3, _ref4, React.createElement("path", {
    d: "M59.29,48.28V30.89a.5.5,0,0,0-.5-.5.59.59,0,0,0-.26.07l-3.78,2.31a.5.5,0,0,0-.24.43v7a.5.5,0,0,0,.17.38l1.14,1A.5.5,0,0,1,56,42v6.33a.5.5,0,0,0,.5.5h2.3A.5.5,0,0,0,59.29,48.28Z",
    style: {
      fillRule: "evenodd"
    }
  }), React.createElement("polygon", {
    points: "26.02 48.26 22.17 48.26 22.17 39.04 20.71 36.71 20.71 30.28 21.8 30.28 21.8 35.45 23.5 35.45 23.5 30.28 24.46 30.28 24.46 35.45 26.02 35.45 26.02 30.28 27.18 30.28 27.18 36.71 26.02 39.04 26.02 48.26",
    style: {
      fillRule: "evenodd"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconUtensils, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-utensils.92136473.svg";
export { ForwardRef as ReactComponent };